
<h5 class="title mb-3">
    {{ 'VISITORS_MEDICAL.SEARCH_VISITOR_TREATMENTS' | translate }}
    <i class="fa pointer text-primary" 
        [ngClass]="{'fa-angle-double-down': !showFilters,
                    'fa-angle-double-up': showFilters}"
        (click)="toggleShowFilters()"></i>
</h5>
<form [formGroup]="searchForm" (ngSubmit)="submit()" #sForm="ngForm" autocomplete="off" [hidden]="!showFilters">
    <div class="row mb-3" *ngIf="!selfVisitor">
        <div class="form-group">
            <div class="col-md-3">
                <label class="control-label control-label-sm" for="visitor_ids" >
                    {{ 'VISITORS_MEDICAL.VISITOR' | translate }}
                </label>
            </div>
            <div class="col-md-9">
                <app-ng-select-add-visitor (changeEvent)="visitorChanged($event)"></app-ng-select-add-visitor>
            </div>
        </div>
    </div>

    <div class="row mt-3">
        <div class="col-md-12">
            <button type="submit"
                    class="btn btn-success btn-fill">
                <i class="fa fa-search"></i> {{ 'SHARED.SEARCH' | translate }}
            </button>
            <button type="button"
                    class="btn btn-danger btn-fill ml-3"
                    (click)="reset()"
                    *ngIf="filledForm">
                <i class="fa fa-close"></i> {{ 'SHARED.RESET' | translate }}
            </button>
        </div>
    </div>
</form>